/**
 * COLLECTION NAMES — Fonte única de verdade para nomes de coleções Firestore.
 *
 * Padrão: camelCase, plural.
 * Todos os services e hooks DEVEM importar daqui em vez de usar strings literais.
 *
 * Uso:
 *   import { COLLECTIONS } from "./collections";
 *   collection(db, "tenants", idTenant, COLLECTIONS.BANK_ACCOUNTS)
 */

// Coleções raiz (nível global)
export const ROOT_COLLECTIONS = {
    TENANTS: "tenants",
    USERS: "users",
    SYSTEM_LOGS: "system_logs",
    PLATFORM_AUDIT_LOGS: "platformAuditLogs",
    PLATFORM_METRICS: "platformMetrics",
    PLATFORM_SUBSCRIPTIONS: "platformSubscriptions",
    PLATFORM_INVOICES: "platformInvoices",
    PLATFORM_PLANS: "platformPlans",
    PUBLIC_CHECKOUT_SESSIONS: "publicCheckoutSessions",
};

// Subcoleções de tenants/{idTenant}/...
export const COLLECTIONS = {
    MEMBERS: "members",
    EMPLOYEES: "employees",
    ROLES: "roles",
    ACTIVITIES: "activities",
    AREAS: "areas",
    LEVELS: "levels",
    CLASSES: "classes",
    SESSIONS: "sessions",
    MEMBERSHIPS: "memberships",
    SERVICES: "services",
    CATALOG: "catalog",
    ACQUIRERS: "acquirers",
    BANK_ACCOUNTS: "bankAccounts",
    WORKOUTS: "workouts",
    SALES: "sales",
    ACCOUNTING_RECORDS: "accountingRecords",
    FINANCIAL_RECORDS: "financialRecords",
    COUNTERS: "counters",
    EVENTS: "events",
    AUDIT_LOGS: "auditLogs",
    ENROLLMENTS: "enrollments",
    EVALUATIONS: "evaluations",
    INTEGRATIONS: "integrations",
    GAMIFICATION: "gamification",
    MEMBER_MEMBERSHIPS: "memberMemberships",
    PHYSICAL_TESTS: "physicalTests",
    PHYSICAL_TEST_RESULTS: "physicalTestResults",
    TESTS: "tests",
    MARKETING_PARTNERS: "marketingPartners",
    ANALYTICS: "analytics",
    XP_LOGS: "xpLogs",
    ATTENDANCE_LOGS: "attendanceLogs",
    AWARDED_ACHIEVEMENTS: "awardedAchievements",
    AUTOMATIONS: "automations",
    AUTOMATION_LOGS: "automationLogs",
    PLANNING_CYCLES: "planningCycles",
    FINANCIAL_CATEGORIES: "financialCategories",
    TASKS: "tasks",
    METRICS: "metrics",
    CASHIER_SHIFTS: "cashierShifts",
    PERFORMANCE_SNAPSHOTS: "performanceSnapshots",
    WAITLIST_ENTRIES: "waitlistEntries",
    MEDIAS: "medias",
    WORKOUT_PRESCRIPTIONS: "workoutPrescriptions",
    WORKOUT_SESSIONS: "workoutSessions",
};
